import { useStore } from '@/store';

const setVieportValue = (isDesktop: boolean) => {
  const viewport = document.querySelector('meta[name=viewport]');
  if (!viewport) return;
  if (isDesktop) {
    viewport.setAttribute('content', 'width=1200');
  } else {
    viewport.setAttribute('content', 'width=device-width,initial-scale=1.0');
  }
};

export const switchDesktopMobileView = (isDesktop: boolean) => {
  const store = useStore();
  setVieportValue(isDesktop);
  store.setDesktopViewForcedCurrent(isDesktop);
};

export default (to: any, from: any, next: Function) => {
  const store = useStore();

  if (to.meta && to.meta.ignoreDesktopViewForced) {
    setVieportValue(false);
  } else if (
    from &&
    from.meta &&
    from.meta.ignoreDesktopViewForced &&
    to.meta &&
    !to.meta.ignoreDesktopViewForced
  ) {
    switchDesktopMobileView(store.desktopViewForced as boolean);
  } else if (
    store.desktopViewForced !== null &&
    store.desktopViewForced !== store.desktopViewForcedCurrent
  ) {
    switchDesktopMobileView(store.desktopViewForced as boolean);
  }

  return next();
};
